<template>
  <div class="table-container">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-table ref="tableSort" v-loading="loading" :data="list" border>
          <el-table-column
            label="序号"
            align="center"
            width="80"
            prop="seq"
          ></el-table-column>
          <el-table-column
            label="处罚日期"
            width="120"
            prop="date"
            align="center"
            :formatter="eighthBitTime"
          ></el-table-column>
          <el-table-column label="决定文书号">
            <template slot-scope="scope">
              {{ scope.row.number || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="处罚内容">
            <template slot-scope="scope">
              {{ scope.row.content || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="处罚机关">
            <template slot-scope="scope">
              {{ scope.row.department || "-" }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100px"
            fixed="right"
            align="center"
            fit="true"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看详情"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-document"
                  circle
                  @click="showDetail(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--分页模块-->
    <el-row v-if="total > 0" :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :background="background"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog
      title="开庭公告详情"
      :visible.sync="flag"
      :close-on-click-modal="false"
      width="55%"
      append-to-body
      @close="close"
    >
      <table
        class="info-table"
        cellspacing="0"
        style="width: 100%; height: 100%"
      >
        <tbody>
          <tr>
            <td>决定文书号</td>
            <td>{{ report.number || "-" }}</td>
          </tr>
          <tr>
            <td>违法行为类型</td>
            <td>{{ report.illegalType || "-" }}</td>
          </tr>
          <tr>
            <td>处罚机关</td>
            <td>{{ report.department || "-" }}</td>
          </tr>
          <tr>
            <td>处罚机关</td>
            <td>{{ report.department || "-" }}</td>
          </tr>
          <tr>
            <td>处罚日期</td>
            <td>
              {{ report.date || "-" }}
            </td>
          </tr>
          <tr>
            <td>公示日期</td>
            <td>{{ report.publishDate || "-" }}</td>
          </tr>
          <tr>
            <td>处罚内容</td>
            <td>{{ report.punishmentText || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
  </div>
</template>

<script>
  import { getPunishments } from "@/api/workplace/companyInfo";
  import { eighthBitTimestamp } from "@/utils";

  export default {
    name: "JobInfo",

    data() {
      return {
        flag: false,
        list: [],
        loading: false,
        total: 0,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        queryForm: {
          body: {
            keyword: "",
            seqId: "",
            skip: 0,
          },
          header: {
            currentTime: "",
            requestId: "2b81a030-bf6c-11ea-a387-f8a2d6d9d88d",
            sourceType: "site",
          },
          pageNum: 1,
          pageSize: 20,
        },
        report: {},
      };
    },

    methods: {
      getPunishments(param) {
        this.loading = true;
        this.obj = param;
        this.queryForm.body.keyword = param.keyword;
        this.queryForm.body.seqId = param.seqId;
        this.queryForm.body.skip = (this.queryForm.pageNum - 1) * 20;
        getPunishments(this.queryForm)
          .then((response) => {
            if (response.header.retCode === "1") {
              this.list = response.body.items;
              this.total = response.body.total;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      },
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.getPunishments(this.obj);
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.getPunishments(this.obj);
      },
      showDetail(row) {
        this.flag = true;
        this.report = row;
      },
      close() {
        this.flag = false;
      },
      // 时分下单日期格式处理
      eighthBitTime(row, column) {
        var date = row[column.property];
        if (date === undefined || date === null) {
          return "-";
        }
        return eighthBitTimestamp(Date.parse(date));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .info-table {
    border-collapse: collapse;
    font-size: 14px;
    color: #333;

    tr td {
      border: 1px solid #ccc;
      padding: 10px;

      &:nth-of-type(even) {
        width: 35%;
        font-weight: normal;
      }

      &:nth-of-type(odd) {
        width: 15%;
        background: #f5f7fa;
      }
    }
  }
</style>
